// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__31uLX","footer":"ModalFilter_footer__30HqA"};